import React, { useEffect, useLayoutEffect, useState } from "react";
import airconService from "../services/aircon.service";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import categoryService from "../services/category.service";
import clientService from "../services/client.service";
import analyticsService from "../services/analytics.service";
import authsService from "../services/auths.service";
import clientcategoryService from "../services/clientcategory.service";
const Preventivemaintenance = () => {
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();
  const client_id = authsService.getclientname();
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);

  const [allmonth, setAllmonth] = useState([]);
  const [aircons, setAircons] = useState([]);
  const [filtermonth, setFiltermonth] = useState((new Date().getMonth() + 1) > 12 ? "1" : (new Date().getMonth() + 1));
  const [filteryear, setFilteryear] = useState(new Date().getFullYear());
  const [filterbuilding, setFilterbuilding] = useState("");
  const [filterblock, setFilterblock] = useState("");
  const [filterlevel, setFilterlevel] = useState("");
  const [filterlocation, setFilterlocation] = useState("");


  const [result, setResult] = useState([]);
  const [categorysfilter, setCategorysfilter] = useState([]);
  const [clientoverviewarr, setClientoverviewarr] = useState({});

  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [filterclient, setFilterclient] = useState(
    client_id === "democlient" ? "" : client_id
  );
  const [filterclientarr, setFilterclientarr] = useState([]);
  const [buildingarr, setBuildingarr] = useState([]);
  const [blockarr, setBlockarr] = useState([]);
  const [levelarr, setLevelarr] = useState([]);
  const [locationarr, setLocationarr] = useState([]);

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("aircon_id");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "aircon ID", value: "" },
    { label: "Type", value: "" },
    { label: "Block", value: "" },
    { label: "Level", value: "" },
    { label: "Unit or Location", value: "" },
    { label: "cleaning status", value: "" },
    { label: "issue status", value: "" },
    { label: "Status", value: "" },
    { label: "updated", value: "" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  //use effects
  useEffect(() => {
    getallAircon();
    getallCategory();
    getallClient();
    getAllmonth();
    getallClientoverview();
  }, []);

  //use effects
  useEffect(() => {
    getalllocation();
    getallblock();
    getalllevel();
    console.log('dfbhdbfhdbhfg');
  }, []);
  useLayoutEffect(() => {
    getallAircon();
    getallClientoverview();
  }, [
    page,
    limit,
    filter,
    filterclient,
    filtermonth,
    filteryear,
    filterbuilding,
    filterblock, filterlevel, filterlocation,
    search,
    between,
    sort,
  ]);

  //get allaircon
  const getallAircon = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filtermonth: filtermonth,
      filteryear: filteryear,
      filterbuilding: filterbuilding,
      filterblock: filterblock,
      filterlevel: filterlevel,
      filterlocation: filterlocation,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconService
      .getallAirconjoin(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          setIsLoaded(false);
          setAircons(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //filter
  const [filterclientArr, setfilterclientArr] = useState([]);
  const filterclientfn = (value) => {
    setPage(1);
    var index = filterclientArr.indexOf(value);
    if (index > -1) {
      filterclientArr.splice(index, 1);
      setFilterclient(filterclientArr.toString());
    } else {
      filterclientArr.push(value);
      setFilterclient(filterclientArr.toString());
    }
  };
  //filter block
  const [filterblockArr, setfilterblockArr] = useState([]);
  const filterblockfn = (value) => {
    setPage(1);
    var index = filterblockArr.indexOf(value);
    if (index > -1) {
      filterblockArr.splice(index, 1);
      setFilterblock(filterblockArr.toString());
    } else {
      filterblockArr.push(value);
      setFilterblock(filterblockArr.toString());
    }
  };
  //filter level
  const [filterlevelArr, setfilterlevelArr] = useState([]);
  const filterlevelfn = (value) => {
    setPage(1);
    var index = filterlevelArr.indexOf(value);
    if (index > -1) {
      filterlevelArr.splice(index, 1);
      setFilterlevel(filterlevelArr.toString());
    } else {
      filterlevelArr.push(value);
      setFilterlevel(filterlevelArr.toString());
    }
  };
  //filter location
  const [filterlocationArr, setfilterlocationArr] = useState([]);
  const filterlocationfn = (value) => {
    setPage(1);
    var index = filterlocationArr.indexOf(value);
    if (index > -1) {
      filterlocationArr.splice(index, 1);
      setFilterlocation(filterlocationArr.toString());
    } else {
      filterlocationArr.push(value);
      setFilterlocation(filterlocationArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort === value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort === value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };

  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
      " , " +
      format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get block
  const getallblock = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "block",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setBlockarr(res.data.result.data);
          console.log('sdmhjdhfuhrduhu', res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get block
  const getalllocation = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "location",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLocationarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get level
  const getalllevel = async () => {
    var data = {
      limit: 500,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtercategory: "level",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setLevelarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get building
  const getallbuilding = async () => {
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filterclient: filterclient,
      filtercategory: "building",
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await clientcategoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setBuildingarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allcategory
  const getallCategory = async () => {
    var data = {
      limit: 50,
      page: 1,
      filter: "",
      filtercategory: "case_status",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await categoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setCategorysfilter(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  //get allclient
  const getAllmonth = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: "",
      search: "",
      between: "",
      sort: "",
      group: "month_name",
    };
    return await analyticsService
      .clientAirconmonthwiseoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setAllmonth(res.data.result.data);
        } else {
          setAllmonth([]);
        }
      })
      .catch((err) => {
        setAllmonth([]);
      });
  };
  //get allclient
  const getallClient = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await clientService
      .getallClient(data)
      .then((res) => {
        if (res.data.result) {
          setFilterclientarr(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };

  //get allclient
  const getallClientoverview = async () => {
    var data = {
      limit: 40,
      page: 1,
      filter: "",
      filterclient: filterclient,
      filtermonth: filtermonth,
      filteryear: filteryear,
      search: "",
      between: "",
      sort: "",
      group: "client_id",
    };
    return await analyticsService
      .clientAirconoverview(data)
      .then((res) => {
        console.log(res.data.result);
        if (res.data.result) {
          setClientoverviewarr(res.data.result.data[0]);
        } else {
          setClientoverviewarr({});
        }
      })
      .catch((err) => {
        setClientoverviewarr({});
      });
  };
  //get alllocation
  /* const getallLocation = async () => {
    var data = {
      limit: 60,
      page: 1,
      filter: "",
      filterclient: filterclient,
      search: "",
      between: "",
      sort: "",
      group: "",
    };
    return await locationService
      .getallLocation(data)
      .then((res) => {
        console.log(res.data);
        if (res.data.result) {
          setBuildingarr(res.data.result.data);
        } else {
          setBuildingarr([]);
        }
      })
      .catch((err) => {
        setBuildingarr([]);
      });
  }; */
  const selectedcolor = (value) => {
    if (value === "new case") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending case") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "case approved") {
      return "badge rounded-pill bg-primary";
    } else if (value === "new case") {
      return "bg-danger ";
    } else if (value === "case received") {
      return "badge rounded-pill bg-primary";
    } else if (value === "case closed") {
      return "badge rounded-pill bg-danger";
    } else if (value === "payment pending") {
      return "badge rounded-pill bg-danger";
    } else if (value === "payment closed") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  const selectedbg = (value) => {
    if (value === "completed") {
      return "bg-success";
    } else if (value === "pending case") {
      return "bg-warning ";
    } else if (value === "new case") {
      return "bg-danger ";
    } else if (value === "case approved") {
      return "bg-primary";
    } else if (value === "case received") {
      return "bg-secondary";
    } else if (value === "case closed") {
      return "bg-info";
    } else if (value === "payment pending") {
      return "bg-warning";
    } else if (value === "payment closed") {
      return "bg-danger";
    } else {
      return "bg-block";
    }
  };
  const selectrandomcolor = () => {
    const colors = [
      "#08EA76",
      "#089BEA",
      "#0FD6A0",
      "#EA6408",
      "#EA086F",
      "#A208EA",
      "#EA086F",
    ];

    const random = Math.floor(Math.random() * colors.length);
    return random, colors[random];
  };
  // Call aircon clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  /* if (isLoaded == true) {
    return <Loader />
  } */

  return (
    <div className="">
      <div className="text-center">
        {/*  loader and error handler */}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="aircon-container">

        <div className="row p-2">
          <div className=" p-1 col-md-3">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-codiepie"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon_unit}
                  </div>
                  <div>Aircon Unit</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-map-marker"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon}
                  </div>
                  <div>Location</div>
                </div>
              </div>
            </div>
          </div>

          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-thumbs-up"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_service}{" "}
                    <span
                      style={{ fontSize: 12, fontWeight: 400 }}
                      className="fw-sm"
                    >
                      Maintenance &nbsp;
                      <span className="badge bg-secondary">  {clientoverviewarr.client_total_maintenance}</span>&nbsp; Issue &nbsp;
                      <span className="badge bg-secondary">   {clientoverviewarr.client_total_issue}</span>
                    </span>
                  </div>
                  <div>Completed</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-thumbs-down"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_aircon -
                      clientoverviewarr.client_total_service
                      ? clientoverviewarr.client_total_aircon -
                      clientoverviewarr.client_total_service
                      : 0}
                  </div>
                  <div>Pending</div>
                </div>
              </div>
            </div>
          </div>
          <div className=" p-1 col-md-3 ">
            <div style={{ borderRadius: 10 }}>
              <div className="bg-white rounded d-flex flex-wrap p-1">
                <div className="ps-2" style={{ fontSize: 20 }}>
                  <i className="fa fa-money"></i>
                </div>
                <div className="flex-fill ps-4">
                  <div style={{ fontSize: 20, fontWeight: 600 }}>
                    {clientoverviewarr.client_total_amount}
                  </div>
                  <div>Issue Cost</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="d-flex  ">
            <h1 className="flex-fill">Adhoc Maintenance</h1><div>{/* <button
              onClick={() => {
                navigate("/clientevent");
              }}
              type="submit"
              className="btn btn-primary"
            >
              <i className="fa fa-plus"></i> Add Client
            </button> */}</div>
          </div>
        </div>
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex  mb-2 ">
          {/* create aircon */}
          {/*    <div className="m-1">
            <button
              onClick={() => {
                navigate("/airconevent");
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> Create
            </button>
          </div> */}

          {/* filter client*/}
          <div
            className={
              userinfos.login_type === "dashboard" ? "dropdown m-1" : "d-none"
            }
          >
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Client
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Client</li>
              {filterclientarr.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterclientfn(filterdata.client_id)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.client_fullname}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  block filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Block
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Block</li>
              {blockarr && blockarr.map((blockarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterblockfn(blockarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {blockarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  level filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Level
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Level</li>
              {levelarr && levelarr.map((levelarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterlevelfn(levelarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {levelarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*  lcoation filter */}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Unit or Location
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary"> Unit or Location</li>
              {locationarr && locationarr.map((locationarr, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterlocationfn(locationarr.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {locationarr.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/*Building filter */}
          <div className="m-1 d-none">
            <select
              onChange={(e) => setFilterbuilding(e.target.value)}
              value={filterbuilding}
              className="form-select"
              aria-label="Select month"
            >
              <option value="">All</option>
              {buildingarr && buildingarr.map((buildingarr, index) => (
                <option key={index} value={buildingarr.location_name}>
                  {buildingarr.location_name}
                </option>
              ))}
            </select>
          </div>
          {/* filter status*/}
          <div
            className={
              userinfos.login_type === "dashboard"
                ? "dropdown m-1 d-none"
                : "d-none"
            }
          >
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Status
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Status</li>
              {categorysfilter && categorysfilter.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.category_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.category_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>

          {/* search */}
          <div
            /*  className={userinfos.login_type === "dashboard" ? "m-1" : "d-none"} */
            className="m-1 d-none"

          >
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search by Id or Location"
              type="search"
            ></input>
          </div>
          {/*  month range  */}
          <div className="m-1 ms-auto">
            <select
              onChange={(e) => setFiltermonth(e.target.value)}
              value={filtermonth}
              className="form-select"
              aria-label="Select month"
            >
              {allmonth.map((allmonth, index) => (
                <option key={index} value={allmonth.month_name}>
                  {allmonth.month_label}
                </option>
              ))}
            </select>
          </div>
          {/*  year range  */}
          <div className="m-1 ">
            <select
              onChange={(e) => {
                setFilteryear(e.target.value);
              }}
              value={filteryear}
              className="form-select"
              aria-label="select year"
            >
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </select>
          </div>
          {/*  date range  */}
          <div className="m-1">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        <div className="mb-2">
          {/*  &nbsp; Filter By : &nbsp;&nbsp; */}
          {filterblockArr.length ? <>
            {filterblockArr.map((filterblockArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterblockArr} </span>
            ))}
          </> : <></>}&nbsp;&nbsp;
          {filterlevelArr.length ? <>
            {filterlevelArr.map((filterlevelArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterlevelArr} </span>
            ))}
          </> : <></>}&nbsp;&nbsp;
          {filterlocationArr.length ? <>
            {filterlocationArr.map((filterlocationArr, i) => (
              <span key={i} className="badge bg-secondary"><i className="fa fa-times-circle-o"></i> {filterlocationArr} </span>
            ))}
          </> : <></>}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2 mt-2">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {tableHeaders.map((data, index) => (
                  <th key={index} scope="col">
                    {data.label}
                    {/* table sort */}
                    {data.value != "" ? (
                      <a
                        onClick={() => sortfn(data.value)}
                        className="btn btn-sm"
                      >
                        <span
                          className={
                            sort === data.value + " asc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={
                            sort === data.value + " desc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </a>
                    ) : (
                      <></>
                    )}
                  </th>
                ))}
                {/* <th scope="col">#</th>
                <th scope="col">aircon name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {/* table data */}
              {aircons ? (
                <>
                  {aircons.map((data, index) => (
                    <tr key={index}>
                      <td>{data.aircon_id}</td>
                      <td>{data.aircon_type}</td>
                      <td>{data.aircon_block}</td>
                      <td>{data.aircon_level}</td>
                      <td>{data.aircon_location}</td>
                      <td style={{ width: 150 }} className="text-center fs-5">
                        {data.amount_count > 0 ? (
                          <span className="text-success">
                            <i className="fa fa-check-square-o"></i>
                          </span>
                        ) : (
                          <span className="text-danger">
                            <i className="fa fa-clock-o"></i>
                          </span>
                        )}
                        {/* {data.amount_count} */}
                      </td>
                      <td style={{ width: 130 }} className="text-center fs-5">
                        {data.ah_type === "issue" &&
                          data.ah_status !== "completed" ? (
                          <span className="text-danger">
                            <i className="fa fa-check-square"></i>
                          </span>
                        ) : data.ah_type === "issue" &&
                          data.ah_status === "completed" ? (
                          <span className="text-success">
                            <i className="fa fa-check-square"></i>
                          </span>
                        ) : (
                          <span className="text-secondary">
                            <i className="fa fa-check-square"></i>
                          </span>
                        )}
                        {/*  {data.ah_type} */}
                      </td>
                      <td>
                        <span className={selectedcolor(data.ah_status)}>
                          {data.ah_status}
                        </span>
                      </td>
                      <td>
                        {data.amount_count > 0 ? (
                          <span>
                            {format(new Date(data.ah_updatedAt), "PPpp")}
                          </span>
                        ) : (
                          <span className="">waiting..</span>
                        )}
                      </td>
                      <td className="p-1 m-0">
                        <Link
                          className="btn btn-light me-2"
                          to={"/airconview?aircon_id=" + data.aircon_id}
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan={10} className="text-center">
                    <div className="text-center p-3">0 data found</div>
                  </td>
                </tr>
              )}
            </tbody>
            <caption className="">
              <div className="d-flex">
                <div className="flex-fill"></div>
                <div className="p-1 "> Items per page </div>
                <div>
                  {" "}
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    className="form-select form-select-sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div>
                <div className="p-1 me-4">
                  {page * limit - limit}-{page * limit} of {resultCount}
                </div>
                <ReactPaginate
                  previousLabel="< Prev"
                  nextLabel="Next >"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pagecount}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={paginationfn}
                  containerClassName="pagination"
                  activeClassName="actives"
                  disabledLinkClassName="text-secondary"
                  forcePage={page - 1}
                />
              </div>
            </caption>
          </table>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Preventivemaintenance;
